
import { WorldCity } from '../types';

// Segunda expansión de Estados Unidos - añadiendo 100 ciudades más (de 362 a 462)
export const unitedStatesAdditionalCities2: WorldCity[] = [
  { name: 'Fargo', slug: 'fargo', population: 125990 },
  { name: 'Eugene', slug: 'eugene', population: 176654 },
  { name: 'Salem', slug: 'salem-oregon', population: 177723 },
  { name: 'Cary', slug: 'cary', population: 174721 },
  { name: 'Bellevue', slug: 'bellevue', population: 151854 },
  { name: 'Coral Springs', slug: 'coral-springs', population: 134394 },
  { name: 'Sterling Heights', slug: 'sterling-heights', population: 134346 },
  { name: 'Ann Arbor', slug: 'ann-arbor', population: 123851 },
  { name: 'Independence', slug: 'independence', population: 123011 },
  { name: 'Westminster', slug: 'westminster-colorado', population: 116317 },
  { name: 'Provo', slug: 'provo', population: 115162 },
  { name: 'Norman', slug: 'norman', population: 128026 },
  { name: 'Centennial', slug: 'centennial', population: 109741 },
  { name: 'Murfreesboro', slug: 'murfreesboro', population: 152769 },
  { name: 'Pearland', slug: 'pearland', population: 131448 },
  { name: 'Richardson', slug: 'richardson', population: 120981 },
  { name: 'Gainesville', slug: 'gainesville', population: 141085 },
  { name: 'Topeka', slug: 'topeka', population: 125310 },
  { name: 'Las Cruces', slug: 'las-cruces', population: 111385 },
  { name: 'Broken Arrow', slug: 'broken-arrow', population: 113540 },
  { name: 'Jurupa Valley', slug: 'jurupa-valley', population: 111398 },
  { name: 'Hillsboro', slug: 'hillsboro', population: 106447 },
  { name: 'Waterbury', slug: 'waterbury', population: 108802 },
  { name: 'Santa Clara', slug: 'santa-clara', population: 127134 },
  { name: 'West Valley City', slug: 'west-valley-city', population: 140230 },
  { name: 'Killeen', slug: 'killeen', population: 153095 },
  { name: 'Costa Mesa', slug: 'costa-mesa', population: 112174 },
  { name: 'Burbank', slug: 'burbank', population: 107337 },
  { name: 'Temecula', slug: 'temecula', population: 110003 },
  { name: 'Antioch', slug: 'antioch', population: 115291 },
  { name: 'Green Bay', slug: 'green-bay', population: 107395 },
  { name: 'Davenport', slug: 'davenport', population: 101724 },
  { name: 'Boulder', slug: 'boulder', population: 108250 },
  { name: 'West Palm Beach', slug: 'west-palm-beach', population: 117415 },
  { name: 'Portsmouth', slug: 'portsmouth-virginia', population: 97915 },
  { name: 'Denton', slug: 'denton', population: 148059 },
  { name: 'Bend', slug: 'bend', population: 99178 },
  { name: 'San Mateo', slug: 'san-mateo', population: 104570 },
  { name: 'Rialto', slug: 'rialto', population: 104026 },
  { name: 'Las Vegas', slug: 'las-vegas-nevada', population: 641903 },
  { name: 'Lewisville', slug: 'lewisville', population: 111822 },
  { name: 'Sandy Springs', slug: 'sandy-springs', population: 108080 },
  { name: 'Lawton', slug: 'lawton', population: 92757 },
  { name: 'Roanoke', slug: 'roanoke', population: 99897 },
  { name: 'South Bend', slug: 'south-bend', population: 103453 },
  { name: 'Sparks', slug: 'sparks', population: 108445 },
  { name: 'Kenosha', slug: 'kenosha', population: 99986 },
  { name: 'Tuscaloosa', slug: 'tuscaloosa', population: 101129 },
  { name: 'Spokane Valley', slug: 'spokane-valley', population: 102976 },
  { name: 'San Angelo', slug: 'san-angelo', population: 101004 },
  { name: 'Quincy', slug: 'quincy-massachusetts', population: 101636 },
  { name: 'Renton', slug: 'renton', population: 106785 },
  { name: 'Mission Viejo', slug: 'mission-viejo', population: 93653 },
  { name: 'Vacaville', slug: 'vacaville', population: 102386 },
  { name: 'Redding', slug: 'redding', population: 93611 },
  { name: 'Chico', slug: 'chico', population: 101475 },
  { name: 'Greeley', slug: 'greeley', population: 108795 },
  { name: 'League City', slug: 'league-city', population: 109387 },
  { name: 'Clinton', slug: 'clinton-township', population: 99513 },
  { name: 'Meridian', slug: 'meridian', population: 117635 },
  { name: 'Inglewood', slug: 'inglewood', population: 109398 },
  { name: 'Edison', slug: 'edison', population: 107588 },
  { name: 'Yakima', slug: 'yakima', population: 96968 },
  { name: 'Sugar Land', slug: 'sugar-land', population: 111026 },
  { name: 'Sandy', slug: 'sandy-utah', population: 96904 },
  { name: 'Cranston', slug: 'cranston', population: 82934 },
  { name: 'Carson', slug: 'carson', population: 95558 },
  { name: 'Santa Monica', slug: 'santa-monica', population: 93076 },
  { name: 'Newport News', slug: 'newport-news', population: 186247 },
  { name: 'Elgin', slug: 'elgin', population: 114797 },
  { name: 'Pompano Beach', slug: 'pompano-beach', population: 112046 },
  { name: 'West Jordan', slug: 'west-jordan', population: 116961 },
  { name: 'Surprise', slug: 'surprise', population: 141664 },
  { name: 'Thornton', slug: 'thornton', population: 141464 },
  { name: 'Roseville', slug: 'roseville-california', population: 147773 },
  { name: 'Pompano Beach', slug: 'pompano-beach-florida', population: 112046 },
  { name: 'Paterson', slug: 'paterson', population: 159732 },
  { name: 'Overland Park', slug: 'overland-park', population: 197238 },
  { name: 'Grand Rapids', slug: 'grand-rapids', population: 198893 },
  { name: 'Santa Clarita', slug: 'santa-clarita', population: 228673 },
  { name: 'Birmingham', slug: 'birmingham-alabama', population: 200733 },
  { name: 'Richmond', slug: 'richmond-virginia', population: 230436 },
  { name: 'Baton Rouge', slug: 'baton-rouge', population: 227470 },
  { name: 'Hialeah', slug: 'hialeah', population: 223109 },
  { name: 'Chesapeake', slug: 'chesapeake', population: 249422 },
  { name: 'Norfolk', slug: 'norfolk', population: 238005 },
  { name: 'Irving', slug: 'irving', population: 256684 },
  { name: 'Garland', slug: 'garland', population: 246018 },
  { name: 'Fremont', slug: 'fremont', population: 230504 },
  { name: 'Scottsdale', slug: 'scottsdale', population: 258069 },
  { name: 'Madison', slug: 'madison', population: 269840 },
  { name: 'Gilbert', slug: 'gilbert', population: 267918 },
  { name: 'Glendale', slug: 'glendale-arizona', population: 248325 },
  { name: 'Winston-Salem', slug: 'winston-salem', population: 249545 },
  { name: 'North Las Vegas', slug: 'north-las-vegas', population: 262527 },
  { name: 'Henderson', slug: 'henderson', population: 320189 },
  { name: 'Chandler', slug: 'chandler', population: 275987 },
  { name: 'Chula Vista', slug: 'chula-vista', population: 275487 },
  { name: 'Buffalo', slug: 'buffalo', population: 278349 },
  { name: 'Durham', slug: 'durham', population: 283506 },
  { name: 'St. Petersburg', slug: 'st-petersburg', population: 258308 },
  { name: 'Irvine', slug: 'irvine', population: 307670 },
  { name: 'Laredo', slug: 'laredo', population: 255205 },
  { name: 'Lubbock', slug: 'lubbock', population: 258862 },
  { name: 'Jersey City', slug: 'jersey-city', population: 292449 }
];
